export default {"src":"/_next/static/media/NhsLogoOnWhite.054b697b.svg","height":150,"width":371,"blurWidth":0,"blurHeight":0};